<template>
    <div>
        <link href="/themes/web/assets/css/unit-detail.css" rel="stylesheet">
    
        <div class="container">
            <div id="notification" class="card" style="height: calc(100vh - 190px)">
                <div class="card-header">
                    <div class="card-title">{{ $t('inbox') }}</div>
                </div>
                <div class="card-body">
                    <template v-if="isLoading == false">
                        <div class="card-content">
                            <div class="notification-list" v-if="inboxes.length > 0">
                                <!-- <div class="notification-item" v-for="(inbox, index) in inboxes" :class="inbox.status == 1?'notification-item is-read':'notification-item'"  @click="openInbox(inbox)"> -->
                                <div class="notification-item" v-for="(inbox, index) in inboxes" :class="inbox.status == 1?'notification-item':'notification-item'"  @click="openInbox(inbox)">
                                    <div class="title">
                                        <h4>{{ inbox.title }}</h4>
                                        <span class="time_1">{{ inbox.time | convertUnitToTime_1 }}</span>
                                    </div>
                                    <div class="desc_1">
                                        {{ inbox.content.slice(0, 280) }}
                                    </div>
    
                                    <div class="d-flex justify-content-between align-items-center">
                                        <div class="tools">
                                            <p v-if="inbox.content.length > 280" class="view-more">{{$t('view_more')}}</p>
                                        </div>
                                        <div class="tools" v-if="inbox.status != 1">
                                            <button class="btn btn-default btn-open-inbox">{{ $t('open') }}</button>
                                        </div>
                                    </div>
                                  
                                </div>
                            </div>
                            <div class="notification-list" v-else>
                              <div class="notification-list-empty">
                                <div class="message">
                                  {{ $t('no_inbox') }}
                                </div>
                                <img src="/themes/web/assets/images/notification-empty.svg" alt="">
                              </div>
                            </div>                        
                        </div>
                                                
                    </template>
                </div>
            </div>
        </div>

        <div class="modal modal-flex" id="readInboxModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="readInboxModal" aria-hidden="true">
            <div class="modal-dialog" style="width: 530px; max-width: 530px;">
                <div class="modal-content" style="padding-bottom: 15px;">
                    <div class="modal-header">
                        <h5 class="modal-title" id="staticBackdropLabel">{{ inbox.title }}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="inbox-body">
                          {{ inbox.content }}
                        </div>
                    </div>
                    <div class="modal-footer" v-if="inbox.status != 1">
                        <button type="button" @click="readInbox(inbox)" class="btn btn-main-border m-auto" style="padding: 8px 15px;">{{ $t('continue_txt') }}</button>
                    </div>
                </div>
            </div>
        </div>
                
    </div>

</template>

<script>
import axios from "axios";
import { pushQueries } from '../../utils/utils'
import { mapGetters } from 'vuex'
import { getInboxs, readInbox } from "../../models/inbox";
import { claimDailyBonus } from "../../models/reward";

export default {
    name: "Inbox",
    title: 'Inbox',

    data() {
        return {
            inbox: {},
            inboxes: [],
            isLoading: true
        };
    },

    created() {
        this.$store.commit('setMenuActive', 'inbox');

        this.fetch();
    },

    methods: {
        async fetch(page = 1) {
            const that = this;

            this.page = page;

            const params = {
                page: this.page,
            };

            pushQueries(this.$router, '/inbox', params);

            await axios.all([
                getInboxs(params),
            ]).then(axios.spread((inbox_response) => {
                that.isLoading = false;

                //that.$store.commit("setLoading", false);

                if (inbox_response.data.code != 0) {
                    return;
                }

                that.inboxes = inbox_response.data.results ? inbox_response.data.results.mails : [];
                console.log(that.inboxes);
            }));
        },

        openInbox(inbox) {
            const that = this;

            that.inbox = inbox;
            $('#readInboxModal').modal('show');
            // if(inbox.status == 1){
            //   $('#readInboxModal').modal('show');

            //   return;
            // }
        },
        readInbox(inbox) {
            const that = this;

            that.$store.commit("setLoading", true);

            readInbox({
                id: inbox.id,
                //is_raw: true
            }).then((response) => {
                that.$store.commit("setLoading", false);

                if (response.data.code != 0) {
                    return;
                }

                this.$store.state.user_info.count_mail_unread-- ;
                inbox.status = 1;
            }).catch(({ response }) => {
                that.$store.commit("setLoading", false);

                console.error(response);
            });
        }
    }
}
</script>

<style scoped>
    /* .container{
        width: 940px;
        padding: 0;
    } */
    .btn-open-inbox{
        font-size: 14px;
        font-weight: 700;
        text-align: center;
        background: linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%), #00A3FF;
        border-radius: 8px;
        color: #FFFFFF;
        padding: 8px 12px;
        gap: 10px;
        outline: none;
        border: none;
    }
    .desc_1{
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 18px;
        letter-spacing: 0.02em;
        color: #000000 !important;
    }
    .title{
        font-style: normal;
        font-weight: 700;
        font-size: 14px;
        line-height: 19px;
        color: #0D0D0C;
    }
    .time_1{
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 19px;
        text-align: right;
        color: #0D0D0C;
    }
    .view-more{
        font-style: normal;
        font-weight: 700;
        font-size: 12px;
        line-height: 16px;
        text-decoration-line: underline;
        color: #11A9FF;
        /* margin: 0; */
        margin-top: 5px;
    }
    .card>.card-body{
        overflow-y: auto;
    }
</style>
